import { Pipe, PipeTransform } from '@angular/core';
import { NOTIFICATION_TYPE_DEFINITIONS } from './notification-type-definitions';

@Pipe({ name: 'notificationTypeKey', standalone: false })
export class NotificationTypeKeyPipe implements PipeTransform {
  transform(notificationTypeId: string | null | undefined, field: 'name' | 'description'): string | null {
    if (!notificationTypeId) return null;
    return NOTIFICATION_TYPE_DEFINITIONS[notificationTypeId]?.[field] ?? notificationTypeId;
  }
}
